// Tek kaynak: uygulama adı ve marka metinleri ("MekandaPro"). "Mekanda" geçişi için sadece burayı değiştir.
export const APP_NAME_PRIMARY = 'Mekanda';   // wordmark'ta lacivert kısım
export const APP_NAME_SUFFIX = 'Pro';        // wordmark'ta turuncu kısım ('' yapılırsa sadece "Mekanda")
export const APP_NAME = [APP_NAME_PRIMARY, APP_NAME_SUFFIX].filter(Boolean).join('');

// Mekân–organizatör eşleştirme ÖZELLİĞİNİN adı (uygulama adı değil)
export const MATCH_FEATURE_NAME = 'Mekân bul';

export const APP_TAGLINE = 'Mekân–Organizatör eşleşme platformu';
export const TEAM_NAME = `${APP_NAME} ekibi`;
export const COPYRIGHT = `${APP_NAME} © ${new Date().getFullYear()}`;

// Rol bazlı ana sayfa (login / root redirect / logo linki tek yerden)
export const ORGANIZER_HOME = '/organizer/home';
export const ORGANIZER_ONBOARDING = '/organizer/profile';
export const organizerNeedsOnboarding = (organizer) => !organizer || organizer.profile_completed === false;
export const STAFF_HOME = '/staff';
export const roleHome = (role) => role === 'individual' ? '/individual' : role === 'organizer' ? ORGANIZER_HOME
  : role === 'pool_manager' ? STAFF_HOME : '/dashboard';
// Staff attached to a member account keep their member home; the staff panel is a menu link.
// A staff-only account without active staff permissions has no home (avoids a redirect loop).
export const userHome = (user) => (user?.role === 'pool_manager'
  && !(Array.isArray(user?.permissions) && user.permissions.includes('pool.view')) ? null : roleHome(user?.role));

